
import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import {
  queryDishById,
  addDish,
  editDish,
  getCategoryList,
  commonDownload
} from '@/api/dish'
import { baseUrl } from '@/config.json'
import { getToken } from '@/utils/cookies'
@Component({
  name: 'addShop',
  components: {
    HeadLable,
    ImageUpload
  }
})
export default class extends Vue {
  private restKey: number = 0
  private textarea: string = ''
  private value: string = ''
  private imageUrl: string = ''
  private detailImageUrl1: string = ''
  private detailImageUrl2: string = ''
  private detailImageUrl3: string = ''
  private detailImageUrl4: string = ''
  private detailImageUrl5: string = ''
  private actionType: string = ''
  private mountCategoryId: number | null = null
  private dishList: any[] = []
  private categoryTreeOptions: any[] = []
  private displayCategoryTreeOptions: any[] = []
  private displayCategoryCascader: number[] = []
  private displayCategoryCascaderProps = {
    value: 'id',
    label: 'name',
    children: 'children',
    emitPath: false,
    multiple: true,
    checkStrictly: true
  }
  private categoryFlatList: any[] = []
  /** 是否参与邀请计桶 */
  private inviteBucketSwitch = false
  private vueRest = '1'
  private headers = {
    token: getToken()
  }
  private ruleForm = {
    name: '',
    id: '',
    price: '',
    code: '',
    image: '',
    detailImage1: '',
    detailImage2: '',
    detailImage3: '',
    detailImage4: '',
    detailImage5: '',
    description: '',
    status: true,
    categoryId: '',
    inviteBucket: 0,
    displayCategoryIds: [] as number[],
    minQuantity: 1,
    sort: undefined as number | undefined
  }

  get rules() {
    return {
      name: [
        {
          required: true,
          validator: (rule: any, value: string, callback: Function) => {
            if (!value) {
              callback(new Error('请输入商品名称'))
            } else {
              // 允许字母/数字/中文/小数点（. 或 。）/星号(*)，限制总长度 2-20
              const reg = /^([A-Za-z0-9\u4e00-\u9fa5\.\u3002*]){2,20}$/
              if (!reg.test(value)) {
                callback(new Error('商品名称输入不符，请输入2-20个字符'))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur'
        }
      ],
      displayCategoryIds: [
        {
          required: true,
          trigger: 'change',
          validator: (rule: any, value: any, callback: Function) => {
            const ids = this.filterDisplayCategoryIds(this.flattenCategoryIds(value))
            if (!ids.length) {
              callback(new Error('请选择展示分类'))
            } else {
              callback()
            }
          }
        }
      ],
      // 允许不上传图片（后端也支持 image 为空）
      image: {
        required: false,
        message: ''
      },
      price: [
        {
          required: true,
          validator: (rules: any, value: string, callback: Function) => {
            if (value === '' || value === null || value === undefined) {
              callback(new Error('请设置商品价格'))
              return
            }
            const reg = /^([1-9]\d{0,5}|0)(\.\d{1,2})?$/
            // 允许 0 元商品（例如退空桶）
            if (!reg.test(value) || Number(value) < 0) {
              callback(new Error('价格须≥0，最多两位小数'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }
      ],
      minQuantity: [
        {
          required: true,
          validator: (rules: any, value: any, callback: Function) => {
            const num = Number(value)
            if (!Number.isFinite(num) || num < 1 || Math.floor(num) !== num) {
              callback(new Error('起售份数必须为大于等于1的整数'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }
      ],
      sort: [
        {
          required: false,
          trigger: 'change',
          validator: (rule: any, value: any, callback: Function) => {
            if (value === '' || value === null || value === undefined) {
              callback()
              return
            }
            const num = Number(value)
            if (!Number.isFinite(num) || num < 0 || Math.floor(num) !== num) {
              callback(new Error('排序须为大于等于0的整数'))
            } else {
              callback()
            }
          }
        }
      ],
      code: [{ required: true, message: '请填写商品码', trigger: 'blur' }]
    }
  }

  created() {
    this.getDishList()
    this.actionType = this.$route.query.id ? 'edit' : 'add'
    const mid = this.$route.query.mountCategoryId
    if (mid != null && mid !== '' && mid !== 'uncategorized') {
      const n = Number(mid)
      this.mountCategoryId = Number.isNaN(n) ? null : n
    }
    if (this.$route.query.id) {
      this.init()
    }
  }

  mounted() {}

  private resolveMountSort(data: any): number | undefined {
    const sorts = data && data.displayCategorySorts
    if (this.mountCategoryId != null && sorts && typeof sorts === 'object') {
      const key = this.mountCategoryId
      const v = sorts[key] != null ? sorts[key] : sorts[String(key)]
      if (v != null && v !== '') {
        return Number(v)
      }
    }
    if (data && data.sort != null && data.sort !== '') {
      return Number(data.sort)
    }
    return undefined
  }

  private async init() {
    queryDishById(this.$route.query.id).then(res => {
      if (res && res.data && res.data.code === 1) {
        this.ruleForm = { ...res.data.data }
        this.ruleForm.price = String(res.data.data.price)
        this.ruleForm.status = res.data.data.status == '1'
        this.ruleForm.sort = this.resolveMountSort(res.data.data)
        this.ruleForm.minQuantity =
          res.data.data.minQuantity != null
            ? Number(res.data.data.minQuantity)
            : 1
        this.inviteBucketSwitch = Number(res.data.data.inviteBucket) === 1
        this.ruleForm.inviteBucket = this.inviteBucketSwitch ? 1 : 0
        const displayIds = Array.isArray(res.data.data.displayCategoryIds)
          ? res.data.data.displayCategoryIds.map((id: any) => Number(id)).filter((id: number) => !Number.isNaN(id))
          : []
        const filteredDisplayIds = this.categoryFlatList.length
          ? this.filterDisplayCategoryIds(displayIds)
          : displayIds
        this.ruleForm.displayCategoryIds = filteredDisplayIds
        this.displayCategoryCascader = filteredDisplayIds
        this.imageUrl = res.data.data.image
        this.detailImageUrl1 = res.data.data.detailImage1 || ''
        this.detailImageUrl2 = res.data.data.detailImage2 || ''
        this.detailImageUrl3 = res.data.data.detailImage3 || ''
        this.detailImageUrl4 = res.data.data.detailImage4 || ''
        this.detailImageUrl5 = res.data.data.detailImage5 || ''
      } else {
        this.$message.error(res.data.msg)
      }
    })
  }

  private getCategoryParentId(item: any) {
    if (!item) return null
    const p = item.parentId != null ? item.parentId : item.parent_id
    if (p == null || p === '' || Number(p) === 0) return null
    return Number(p)
  }

  private buildCategoryTree(
    list: any[],
    opts?: {
      selectableDepths?: number[]
      checkLeavesOnly?: boolean
      /** 树最多展示到第几级（展示分类用 2，不渲染三级） */
      maxDepth?: number
    }
  ) {
    const pool = Array.isArray(list) ? list : []
    const selectable = opts && opts.selectableDepths ? opts.selectableDepths : null
    const leavesOnly = !!(opts && opts.checkLeavesOnly)
    const maxDepth = opts && opts.maxDepth != null ? opts.maxDepth : 0
    const childMap: Record<string, any[]> = {}
    pool.forEach((c) => {
      const pid = this.getCategoryParentId(c)
      const key = pid == null ? 'root' : String(pid)
      if (!childMap[key]) childMap[key] = []
      childMap[key].push(c)
    })
    const attach = (nodes: any[], depth: number): any[] =>
      nodes
        .sort((a, b) => (a.sort || 0) - (b.sort || 0))
        .map((n) => {
          const rawKids = childMap[String(n.id)]
          const allowChildren = !maxDepth || depth < maxDepth
          const kids = allowChildren && rawKids && rawKids.length ? rawKids : null
          const hasKids = !!(kids && kids.length)
          const label =
            Number(n.status) === 1 ? n.name : `${n.name}（未启用，请到分类管理启用）`
          const disabledByStatus = Number(n.status) !== 1
          let disabled = disabledByStatus
          if (selectable) {
            if (leavesOnly) {
              if (!hasKids) {
                disabled = disabledByStatus || selectable.indexOf(depth) < 0
              }
            } else {
              disabled = disabledByStatus || selectable.indexOf(depth) < 0
            }
          }
          if (hasKids) {
            return {
              id: n.id,
              name: label,
              children: attach(kids, depth + 1),
              disabled
            }
          }
          return {
            id: n.id,
            name: label,
            disabled
          }
        })
    const roots = childMap.root || []
    return attach(roots, 1)
  }

  private getCategoryDepthById(categoryId: number): number {
    const item = (this.categoryFlatList || []).find(
      (c: any) => Number(c.id) === Number(categoryId)
    )
    if (!item) return 0
    let depth = 1
    let pid = this.getCategoryParentId(item)
    const map: Record<string, any> = {}
    ;(this.categoryFlatList || []).forEach((c: any) => {
      if (c && c.id != null) map[String(c.id)] = c
    })
    let guard = 0
    while (pid != null && map[String(pid)] && guard < 8) {
      depth++
      pid = this.getCategoryParentId(map[String(pid)])
      guard++
    }
    return depth
  }

  private filterDisplayCategoryIds(ids: number[]): number[] {
    return (ids || []).filter((id) => this.getCategoryDepthById(id) === 2)
  }

  private flattenCategoryIds(val: any): number[] {
    const out: number[] = []
    const walk = (v: any) => {
      if (v == null || v === '') return
      if (Array.isArray(v)) {
        v.forEach(walk)
        return
      }
      const n = Number(v)
      if (!Number.isNaN(n)) out.push(n)
    }
    walk(val)
    return Array.from(new Set(out))
  }

  private onDisplayCategoryChange(val: number[] | null) {
    const ids = this.filterDisplayCategoryIds(this.flattenCategoryIds(val))
    this.ruleForm.displayCategoryIds = ids
    this.displayCategoryCascader = ids
  }

  private findParentCategoryId(categoryId: number): number | null {
    const item = (this.categoryFlatList || []).find(
      (c: any) => Number(c.id) === Number(categoryId)
    )
    return this.getCategoryParentId(item)
  }

  // 获取商品分类（树形级联）
  private getDishList() {
    getCategoryList({ type: 1 }).then(res => {
      if (res.data.code === 1) {
        this.categoryFlatList = (res && res.data && res.data.data) || []
        this.displayCategoryTreeOptions = this.buildCategoryTree(this.categoryFlatList, {
          selectableDepths: [2],
          maxDepth: 2
        })
        if (this.ruleForm.displayCategoryIds && this.ruleForm.displayCategoryIds.length) {
          const ids = this.filterDisplayCategoryIds([...this.ruleForm.displayCategoryIds])
          this.ruleForm.displayCategoryIds = ids
          this.displayCategoryCascader = ids
        }
      } else {
        this.$message.error(res.data.msg)
      }
    })
  }

  private submitForm(formName: any, st: any) {
    (this.$refs[formName] as any).validate((valid: any) => {
      console.log(valid, 'valid')
      if (valid) {
        let params: any = { ...this.ruleForm }
        params.status =
          this.actionType === 'add' ? 0 : this.ruleForm.status ? 1 : 0
        // 品牌分类字段改为邀请计桶开关；不再提交三级品牌
        params.categoryId = null
        params.inviteBucket = this.inviteBucketSwitch ? 1 : 0
        params.displayCategoryIds = this.filterDisplayCategoryIds(
          this.flattenCategoryIds(this.ruleForm.displayCategoryIds)
        )
        if (this.ruleForm.sort == null) {
          params.sort = null
        } else {
          params.sort = Number(this.ruleForm.sort)
        }
        if (this.mountCategoryId != null) {
          params.mountCategoryId = this.mountCategoryId
        }
        params.flavors = []
        if (this.actionType == 'add') {
          delete params.id
          addDish(params)
            .then(res => {
              if (res.data.code === 1) {
                this.$message.success('商品添加成功！')
                if (!st) {
                  this.$router.push({ path: '/dish' })
                } else {
                  this.imageUrl = ''
                  this.detailImageUrl1 = ''
                  this.detailImageUrl2 = ''
                  this.detailImageUrl3 = ''
                  this.detailImageUrl4 = ''
                  this.detailImageUrl5 = ''
                  this.inviteBucketSwitch = false
                  this.displayCategoryCascader = []
                  this.ruleForm = {
                    name: '',
                    id: '',
                    price: '',
                    code: '',
                    image: '',
                    detailImage1: '',
                    detailImage2: '',
                    detailImage3: '',
                    detailImage4: '',
                    detailImage5: '',
                    description: '',
                    status: true,
                    categoryId: '',
                    inviteBucket: 0,
                    displayCategoryIds: [],
                    minQuantity: 1,
                    sort: undefined
                  }
                  this.restKey++
                }
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        } else {
          delete params.createTime
          delete params.updateTime
          editDish(params)
            .then(res => {
              if (res && res.data && res.data.code === 1) {
                this.$router.push({ path: '/dish' })
                this.$message.success('商品修改成功！')
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
              // if (res.data.code == 200) {
              //   this.$router.push({'path': '/dish'})
              //   this.$message.success('商品修改成功！')
              // } else {
              //   this.$message.error(res.data.desc || res.data.message)
              // }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        }
      } else {
        return false
      }
    })
  }

  imageChange(value: any) {
    this.ruleForm.image = value
  }
  detailImageChange(index: number, value: any) {
    if (index === 1) {
      this.ruleForm.detailImage1 = value
      this.detailImageUrl1 = value || ''
    } else if (index === 2) {
      this.ruleForm.detailImage2 = value
      this.detailImageUrl2 = value || ''
    } else if (index === 3) {
      this.ruleForm.detailImage3 = value
      this.detailImageUrl3 = value || ''
    } else if (index === 4) {
      this.ruleForm.detailImage4 = value
      this.detailImageUrl4 = value || ''
    } else if (index === 5) {
      this.ruleForm.detailImage5 = value
      this.detailImageUrl5 = value || ''
    }
  }
}
